import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const groundingLocationTypesAdapter = getAdapter({ idFieldName: 'value' });

const groundingLocationTypesSlice = createSlice({
  name: 'groundingLocationTypes',
  initialState: groundingLocationTypesAdapter.getInitialState(),
  reducers: {
    setGroundingLocationTypes: (state, { payload: { groundingLocationTypes } }) => {
      groundingLocationTypesAdapter.setAll(state, groundingLocationTypes);
    },
  },
});

const selectors = groundingLocationTypesAdapter.getSelectors(({ groundingLocationTypes }) => groundingLocationTypes);

export const getAllGroundingLocationTypes = (state) => selectors.selectAll(state);

export const {
  setGroundingLocationTypes,
} = groundingLocationTypesSlice.actions;

export default groundingLocationTypesSlice.reducer;
